var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunningVehicle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 138,
    viewBox: "0 0 45 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1011 57.4248H44.1434C44.6171 57.4248 44.9997 57.8087 44.9997 58.2839V68.5525C44.9997 69.0278 44.6171 69.4117 44.1434 69.4117H39.1011V57.4248Z",
    fill: "#3B464E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7019 69.4072H1.65957C1.18586 69.4072 0.803244 69.0234 0.803244 68.5481L0.803244 58.2795C0.803244 57.8042 1.18586 57.4204 1.65957 57.4204H6.7019L6.7019 69.4072Z",
    fill: "#3B464E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1008 70.4443H44.1432C44.6169 70.4443 44.9995 70.8282 44.9995 71.3035V81.5721C44.9995 82.0473 44.6169 82.4312 44.1432 82.4312H39.1008V70.4443Z",
    fill: "#3B464E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70166 82.4268H1.65933C1.18562 82.4268 0.803 82.0429 0.803 81.5676L0.803 71.299C0.803 70.8238 1.18562 70.4399 1.65933 70.4399H6.70166L6.70166 82.4268Z",
    fill: "#3B464E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1008 102.924H44.1432C44.6169 102.924 44.9995 103.308 44.9995 103.783V114.052C44.9995 114.527 44.6169 114.911 44.1432 114.911H39.1008V102.924Z",
    fill: "#3B464E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7019 114.906H1.65957C1.18586 114.906 0.803244 114.522 0.803244 114.047L0.803244 103.779C0.803244 103.303 1.18586 102.919 1.65957 102.919H6.7019L6.7019 114.906Z",
    fill: "#3B464E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1008 115.945H44.1432C44.6169 115.945 44.9995 116.329 44.9995 116.804V127.073C44.9995 127.548 44.6169 127.932 44.1432 127.932H39.1008V115.945Z",
    fill: "#3B464E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70142 127.933H1.65909C1.18537 127.933 0.802756 127.549 0.802756 127.073L0.802756 116.805C0.802756 116.33 1.18537 115.946 1.65909 115.946H6.70142L6.70142 127.933Z",
    fill: "#3B464E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89945 49.123H37.8938C40.3945 49.123 42.426 51.1612 42.426 53.6701V130.627C42.426 134.224 39.5154 137.144 35.9306 137.144H9.86719C6.28244 137.144 3.37183 134.224 3.37183 130.627V53.6701C3.37183 51.1612 5.40333 49.123 7.904 49.123H7.89945Z",
    fill: "#4CAF50"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8782 49.126H32.9246C33.7019 49.126 34.332 48.4938 34.332 47.7139C34.332 46.934 33.7019 46.3018 32.9246 46.3018H12.8782C12.1009 46.3018 11.4707 46.934 11.4707 47.7139C11.4707 48.4938 12.1009 49.126 12.8782 49.126Z",
    fill: "#222B32"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5689 49.126H33.2393V45.1364H12.5689V49.126Z",
    fill: "#3B464E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1314 7.24473H7.67244C6.02355 7.24473 5.02601 5.42133 5.90512 4.01837C7.35359 1.71971 9.90436 0.193359 12.8104 0.193359H12.9197V4.89579H32.8795V0.193359H32.9888C35.8995 0.193359 38.4502 1.71971 39.8987 4.01837C40.7778 5.41676 39.7803 7.24473 38.1314 7.24473Z",
    fill: "#D32F2F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1968 1.72168H32.6009C36.9327 1.72168 40.4491 5.24965 40.4491 9.59563V40.9909C40.4491 43.3947 38.5041 45.346 36.1082 45.346H9.6895C7.2936 45.346 5.34863 43.3947 5.34863 40.9909V9.59563C5.34863 5.24965 8.86505 1.72168 13.1968 1.72168Z",
    fill: "#696969"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3654 23.0107H32.4325C35.7849 23.0107 38.5042 25.739 38.5042 29.1024V38.5713C38.5042 40.975 36.5593 42.9264 34.1634 42.9264H11.6346C9.23866 42.9264 7.2937 40.975 7.2937 38.5713V29.1024C7.2937 25.739 10.013 23.0107 13.3654 23.0107Z",
    fill: "#E1EAEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46139 22.0537H2.65345C2.35661 22.0537 2.11597 22.2951 2.11597 22.593V22.9905C2.11597 23.2884 2.35661 23.5298 2.65345 23.5298H6.46139C6.75823 23.5298 6.99887 23.2884 6.99887 22.9905V22.593C6.99887 22.2951 6.75823 22.0537 6.46139 22.0537Z",
    fill: "#E4EDF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3418 23.5293H43.1498C43.4466 23.5293 43.6873 23.2879 43.6873 22.99V22.5925C43.6873 22.2946 43.4466 22.0532 43.1498 22.0532H39.3418C39.045 22.0532 38.8043 22.2946 38.8043 22.5925V22.99C38.8043 23.2879 39.045 23.5293 39.3418 23.5293Z",
    fill: "#E4EDF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningVehicle);
export default __webpack_public_path__ + "static/media/running_vehicle.d17f82e7c8f4d46b66ea9c6fce7e727f.svg";
export { ForwardRef as ReactComponent };